import { getGridNumericOperators, getGridStringOperators } from '@mui/x-data-grid';
import i18n from '../../../i18n';
import { formatDateTime, formatPhone } from '../../../utils/formatters';

// https://v7.mui.com/x/react-data-grid/filtering/customization/

// contact column uses field 'contact_name' so the filter sends ?contact_name=...
// matching the backend LeadContactFilterMixin filter names.
export const COLUMNS = [
  {
    field: 'contact_name',
    headerName: 'Contato',
    width: 260,
    // flex: 1.5,
    sortable: false,
    valueGetter: (value, row) => row.contact?.display_name ?? '',
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === 'equals' || operator.value === 'contains' || operator.value === 'startsWith',
    ),
  },
  {
    field: 'contact_phone',
    headerName: 'Telefone',
    width: 160,
    // flex: 1.5,
    sortable: false,
    valueGetter: (value, row) => row.contact?.phone_number ?? '',
    valueFormatter: (value) => formatPhone(value),
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === 'equals' || operator.value === 'contains',
    ),
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 120,
    sortable: false,
    // renderCell: ({ value }) => {
    //   const chip = STATUS_CHIP[value] ?? { label: value, color: 'default' };
    //   return <Chip label={chip.label} color={chip.color} size="small" />;
    // },
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === 'equals' || operator.value === 'isAnyOf',
    ),
  },
  {
    field: 'summary',
    headerName: 'Resumo',
    flex: 1.5,
    sortable: false,
    filterable: false,
    valueGetter: (value, row) => row.insight?.summary ?? '',
  },
  {
    field: 'assigned_to_name',
    headerName: 'Responsável',
    flex: 1,
    sortable: false,
    filterable: false,
    valueGetter: (value, row) => row.assigned_to_name ?? '',
  },
  {
    field: 'last_message_at',
    headerName: 'Última mensagem',
    width: 180,
    sortable: true,
    valueFormatter: (value) =>
      formatDateTime(value, i18n.language, { empty: '' }),
    // filterOperators: DATE_OPS,
  },
  {
    field: 'latest_temperature',
    headerName: 'Temperatura',
    width: 120,
    sortable: true,
    type: 'number',
    valueFormatter: (value) => (value != null ? value : ''),
    // filterOperators: NUMERIC_OPS,
  },
  {
    field: 'latest_sentiment',
    headerName: 'Sentimento',
    width: 120,
    sortable: true,
    type: 'number',
    valueFormatter: (value) => (value != null ? value : ''),
    // filterOperators: NUMERIC_OPS,
  },
  // {
  //   field: 'unread_count',
  //   headerName: 'Não lidas',
  //   width: 100,
  //   sortable: true,
  //   filterable: false,
  // },
];
